import { useState, useEffect } from "react";
import { Form, Button, InputNumber, Space, Typography } from "antd";

const { Text } = Typography;

const FormBatchWalletStacking = (props) => {
  useEffect(() => {
    form.setFieldsValue(props.initialValues);
  }, [props.initialValues]);

  const [form] = Form.useForm();
  const [checkEdit, setCheckEdit] = useState(true);

  const checkEditEnable = (value) => {
    setCheckEdit(value);
  };
  const checkEditDisable = (value) => {
    setCheckEdit(value);
    form.setFieldsValue(props.initialValues);
  };
  const onFinish = async (values) => {
    props.onFinish(values, props.type);
  };
  return (
    props.initialValues &&
    props.initialValues.defaultData && (
      <Form form={form} onFinish={onFinish}>
        <div className="customTable">
        <table>
          <thead>
            <tr>
              <th>Batch</th>
              <th>Cash limit (PKR)</th>
              <th>Total order value Limit (PKR)</th>
              <th>Stacking limit (# of orders)</th>
              <th>Stacking distance</th>
              {/* <th>Assignment Interval (Mins)</th> */}
              <th>
                {props.initialValues.defaultData.length != 0 ? (
                  checkEdit ? (
                    <Form.Item>
                      <Button style={{marginBottom: "0",}} onClick={() => checkEditEnable(false)}>Edit</Button>
                    </Form.Item>
                  ) : (
                    <Form.Item>
                      <Space>
                        <Button className="submit" htmlType="submit">Submit</Button>
                        <Button onClick={() => checkEditDisable(true)}>Cancel</Button>
                      </Space>
                    </Form.Item>
                  )
                ) : (
                  ""
                )}
              </th>
            </tr>
          </thead>
          {props.initialValues.defaultData.length != 0 ? (
            <tbody>
              <Form.List name={"defaultData"}>
                {(fields) => (
                  <>
                    {fields.map((field, index) => {
                      return (
                        <tr>
                          <td>
                            <Form.Item
                              disabled
                              name={[field.name, "batchLevel"]}
                            >
                              <InputNumber disabled />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={[field.name, "cash_limit"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Cash Limit is Required",
                                },
                                {
                                  type: "number",
                                  min: 1,
                                  message: "Please enter minimum amount",
                                },
                                // {
                                //   type: "number",
                                //   max: 10000,
                                //   message: "Please maximum amount",
                                // },
                              ]}
                            >
                              <InputNumber
                                disabled={checkEdit === false ? false : true}
                                min={1}
                                placeholder="Cash limit (PKR)"
                                prefix={<Text>Rs </Text>}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={[field.name, "order_value_limit"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Total order value limit is required",
                                },
                                {
                                  type: "number",
                                  min: 1,
                                  message: "Please enter minimum amount",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={checkEdit === false ? false : true}
                                min={1}
                                placeholder="Total order value Limit (PKR)"
                                prefix={<Text>Rs </Text>}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={[field.name, "stacking_limit"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Stacking limit (# of orders) is required",
                                },
                                {
                                  type: "number",
                                  min: 1,
                                  message: "Please enter minimum amount",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={checkEdit === false ? false : true}
                                min={1}
                                placeholder="Stacking limit (# of orders)"
                                prefix={<Text># </Text>}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={[field.name, "stackingDistance"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Stacking distance",
                                },
                                {
                                  type: "number",
                                  min: 0.01,
                                  message: "Please enter minimum distance",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={checkEdit === false ? false : true}
                                min={0.01}
                                placeholder="Stacking distance"
                                prefix={<Text># </Text>}
                              />
                            </Form.Item>
                          </td>
                          {/* <td>
                            <Form.Item
                              name={[field.name, "assignmentInterval"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Assignment Interval",
                                },
                                {
                                  type: "number",
                                  min: 0,
                                  message: "Assignment interval must be over 0 mins",
                                },
                                {
                                  type: "number",
                                  max: 30000,
                                  message: "Assignment interval must be under 30000 mins",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={checkEdit === false ? false : true}
                                min={0}
                                placeholder="Assignment Interval"
                                // prefix={<Text>Mins </Text>}
                              />
                            </Form.Item>
                          </td> */}
                          <td>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </Form.List>
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  Please Select Zone
                </td>
              </tr>
            </tbody>
          )}
        </table>
        </div>
      </Form>
    )
  );
};
export default FormBatchWalletStacking;